module.exports = __webpack_public_path__ + "static/media/profile_avatar.95aef263.png";